import { render, staticRenderFns } from "./DonutChart87.vue?vue&type=template&id=d6b76b68&scoped=true"
import script from "./DonutChart87.vue?vue&type=script&lang=js"
export * from "./DonutChart87.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b76b68",
  null
  
)

export default component.exports